module.exports = __webpack_public_path__ + "img/IMG_6626-Edit.4fa4f1d7.jpg";